import {ListUsersParams} from '../../types/interfaces';

export class FetchUserParamsList {
  static readonly type = '[ListUsersParams] Fetch All';

  constructor(public payload: ListUsersParams) {
  }
}
